<template>
    <button v-on:click="handleClick()" :class="getClassesByType()">
        <i v-if="props.icon" class="pi" :class="props.icon"></i>
        
        <span v-if="props.textContent" :class="props.textClass">
            {{ props.textContent }}
        </span>
    </button>
</template>


<script setup>
import { defineProps, defineEmits } from 'vue';
import urlHandler from '@/composables/urlHandler';

const props = defineProps({
    icon: {
        type: String,
        required: false,
        default: ''
    },
    to: {
        type: String,
        required: false,
        default: ''
    },
    params: {
        type: Object,
        required: false,
        default: null
    },
    type: {
        type: String,
        required: false,
        default: 'SIMPLE'
    },
    customClass: {
        type: String,
        required: false,
        default: ''
    },
    textContent: {
        type: String,
        required: false,
        default: ''
    },
    textClass: {
        type: String,
        required: false,
        default: 'text-white text-xl fontAnton'
    }
});

const emit = defineEmits([
    'clicked'
]);

const classesByType = {
    SIMPLE: `flex items-center justify-center h-11 w-11 rounded-full 
        bg-[#f3e5d4] text-[#7d140f] hover:bg-[#ea6b1d] hover:text-white transition-all`,

    BORDER: `h-11 w-11 rounded-full bg-[#981515] text-white font-bold text-sm 
        border-2 border-transparent group-hover:border-[#ea6b1d] transition-all`
}

/**
 * Gets Classes by informed TYPE
 * @returns {String}
 */
function getClassesByType() {
    const selectedClasses = classesByType[props.type] || classesByType.SIMPLE;

    return `${selectedClasses} ${props.customClass}`;
}

function handleClick() {
    emit('clicked');

    if (props.to) {
        urlHandler.redirectAndScroll(props.to, props.params);
    }
}

// props.customClass
</script>